<script>
	import { onMount, afterUpdate } from 'svelte';

	export let inputElement;
	let canvasElement;
	export let inputString = '';
	export let onkeydown;
	export let wrapperClass = '';
	export let customStyles = '';
	export let placeholder = 'Ask me anything...';
	export let placeholderColor = '';
	export let disabled;
	export let nextText = 'magicInputString';
	export let speed = 1;
	export let dominateFocus = false;
	let canvasStyles = '';
	// afterUpdate(() => {
	// 	if (inputElement) {
	// 		inputElement.style.height = '0px;';
	// 		inputElement.style.height = (inputElement.scrollHeight) + 'px';
	// 	}
	// });
	$: {
		console.log(inputString);
		setTimeout(adjustHeight, 50);
	}

	let adjustOnChange = (node) => {
		var observer = new MutationObserver(function () {
			adjustHeight();
		});

		observer.observe(node, { childList: true, subtree: true });
	};
	onMount(() => {
		typeof window != 'undefined' && document.body.clientWidth > 600 && inputElement?.focus();
		window[nextText] = {};
		window[nextText].keyDown = handleKeydown;
		// return () => {
		// 	window[nextText] = null;
		// 	handleKeydown({ key: 'Enter' });
		// };
		// setHeight();
		if (dominateFocus) {
			inputElement.addEventListener('blur', function (event) {
				// Refocus on the textarea
				inputElement?.focus();
			});
		}
	});
	function setHeight(node) {
		if (!(inputElement || node)) return;
		let el = node || inputElement;
		el.style.height = '0px;';
		el.style.height = el.scrollHeight + 'px';
	}
	let showCanvas = false;

	let pixelData = [];
	function getLinesForParagraphs(ctx, text, maxWidth) {
		return text
			.split('\n')
			.map((para) => getLines(ctx, para, maxWidth))
			.reduce((a, b) => a.concat(b), []);
	}
	function getLines(ctx, text, maxWidth) {
		var words = text?.split(' ').map((w) => w.replace(/\t/g, '    '));

		var lines = [];
		var currentLine = words[0];

		for (var i = 1; i < words?.length; i++) {
			var word = words[i];
			var width = ctx.measureText(currentLine + ' ' + word).width;
			if (width < maxWidth) {
				currentLine += ' ' + word;
			} else {
				lines.push(currentLine);
				currentLine = word;
			}
		}
		lines.push(currentLine);
		return lines;
	}
	function copyInputStringToCanvas() {
		let rawImagePixelIndex, xRawImagePixelIndex;
		let canvas = canvasElement,
			context = canvas?.getContext('2d');
		if (!context) return;

		// let charLength = Math.floor(inputElement.clientWidth / 8.5);
		// console.log({ charLength });
		let computedStyle = window.getComputedStyle(inputElement);
		let computedFontSize = 2 * +computedStyle.fontSize.slice(0, -2);
		console.log(computedFontSize);
		let dimensions = Math.round(inputElement?.clientWidth);
		let padding = +computedStyle.padding.slice(0, -2);
		canvasStyles = `top: ${padding}px; left: ${padding}px;`;
		console.log(padding);

		(canvas.width = dimensions),
			(canvas.height = dimensions),
			// font should 32px "Exo 2"', and set font weight to 600/semibold if
			(context.font =
				(nextText === 'magicButtonText' ? '600' : '') + ' ' + computedFontSize + 'px system-ui'),
			// (context.wordSpacing = '0px'),
			(context.letterSpacing = '0.6px'),
			context.clearRect(0, 0, dimensions, dimensions),
			(context.fillStyle = '#FFF');
		let lines = getLinesForParagraphs(context, inputString, dimensions - 40);

		lines.forEach((line, i) => {
			context.fillText(line, computedFontSize / 4, 18 + computedFontSize / 2 + 48 * i);
		});
		// 	context.fillText(inputString.slice(0, charLength), 16, 24);
		// context.fillText(inputString.slice(charLength, 2 * charLength), 16, 72);
		// console.log(dimensions, dimensions);
		let imageData = context.getImageData(0, 0, dimensions, dimensions),
			rawImageData = imageData.data;
		pixelData = [];
		// console.log(pixelData)
		for (let y = 0; y < dimensions; y++) {
			xRawImagePixelIndex = 4 * y * dimensions;
			for (let x = 0; x < dimensions; x++) {
				if (
					0 !== rawImageData[(rawImagePixelIndex = xRawImagePixelIndex + 4 * x)] &&
					0 !== rawImageData[rawImagePixelIndex + 1] &&
					0 !== rawImageData[rawImagePixelIndex + 2]
				)
					pixelData.push({
						x: x,
						y: y,
						color: [
							rawImageData[rawImagePixelIndex],
							rawImageData[rawImagePixelIndex + 1],
							rawImageData[rawImagePixelIndex + 2],
							rawImageData[rawImagePixelIndex + 3]
						]
					});
			}
		}

		pixelData = pixelData.map((e) => {
			let { x: t, y: r, color: n } = e;
			return {
				x: t,
				y: r,
				r: 1,
				color: 'rgba('.concat(n[0], ', ').concat(n[1], ', ').concat(n[2], ', ').concat(n[3], ')')
			};
		});

		return dimensions;
	}

	function handleKeydown(event, why) {
		// console.log('handleKeydown', event);
		if ('Enter' === event.key && !event.shiftKey) {
			event.preventDefault?.();
			console.log(inputString, onkeydown, why);
			onkeydown?.(event, 'why' + why);
			if (!inputString) return;
			// setTimeout(() => {
			// 	let height = inputElement.clientHeight;
			// 	canvasElement.parentNode.style.height = height + 2 + 'px';
			// 	canvasElement.parentNode.style.marginLeft = '-1px';
			// 	canvasElement.parentNode.style.cssText = ''
			// }, 500);
			let dimensions;
			let initialWidth;
			if (inputString?.length < 180) {
				try {
					dimensions = copyInputStringToCanvas();
				} catch (e) {
					console.log(inputString, e);
				}
				inputString = ' ';
				initialWidth = pixelData.reduce(
					(pixelAgg, pixelData) =>
						pixelData.r > 0 ? (pixelData.x < pixelAgg ? pixelAgg : pixelData.x) : pixelAgg,
					0
				);
				// console.log('initialWidth', initialWidth, pixelData);
			}

			if (dimensions) {
				showCanvas = true;
				try {
					vanishCanvasToWidth(initialWidth);
				} catch (e) {
					console.log(inputString, e);
				}
			} else {
				showCanvas = false;
				inputString = '';
				adjustHeight();
			}
			setTimeout(() => {
				adjustHeight();
			}, 3500);
			function vanishCanvasToWidth(newWidthTarget = 0) {
				let newDelta = Math.round(
					speed * Math.max(10, Math.round((6 * newWidthTarget + dimensions) / 40))
				);
				// console.log('vanishCanvasToWidth', newWidthTarget);
				let rModifier = 0.015 * newDelta;
				requestAnimationFrame(() => {
					let newPixelArray = [];
					for (let i = 0; i < pixelData?.length; i++) {
						let pixel = pixelData[i];
						if (pixel.x < newWidthTarget) newPixelArray.push(pixel);
						else {
							if (pixel.r <= 0) {
								pixel.r = 0;
								continue;
							}
							pixel.x = pixel.x + (Math.random() > 0.5 ? 1 : -1);
							pixel.y = pixel.y + (Math.random() > 0.5 ? 1 : -1);
							pixel.r = pixel.r - rModifier * Math.random();
							newPixelArray.push(pixel);
						}
					}
					pixelData = newPixelArray;
					// console.log('pixelData3', pixelData);
					let e = newWidthTarget,
						canvas = canvasElement,
						context = canvas?.getContext('2d');
					if (!context) return;
					context.clearRect(e, 0, dimensions, dimensions);
					pixelData.forEach((t) => {
						let { x: x, y: y, r: pixelSize1, color: color } = t;
						x > e &&
							(context.beginPath(),
							context.rect(x, y, pixelSize1, pixelSize1),
							(context.fillStyle = color),
							(context.strokeStyle = color),
							context.stroke());
					});
					if (pixelData?.length > 0) {
						// console.log('newDelta', newDelta);
						vanishCanvasToWidth(newWidthTarget - newDelta);
					} else {
						showCanvas = false;
						inputString = window[nextText || 'magicInputString']?.text || '';
						if (!inputElement) return;
						adjustHeight();
						setTimeout(() => {
							adjustHeight();
						}, 50);
					}
				});
			}
		} else onkeydown?.(event);
	}
	function animateOut() {
		console.log('animateOut');
		// handleKeydown({ key: 'Enter' });
	}
	export let hide;
	let shadowTextarea;
	function adjustHeight() {
		console.log('adjustHeight');
		if (!inputElement) return;
		let w = getComputedStyle(inputElement).width;

		shadowTextarea.style.width = w;
		shadowTextarea.value = inputElement.value;
		shadowTextarea.style.height = '0px';
		shadowTextarea.style.height = 'min-content';

		inputElement.style.height =
			inputElement.value.includes('\n') ||
			(inputElement.value?.length || 0) > Math.round(Number(w.replace('px', '')) / 9)
				? shadowTextarea.scrollHeight - 4 + 'px'
				: '62px';
		if (!inputString) {
			inputElement.style.height = '62px';
		}
	}
</script>

<div on:click|stopPropagation class="relative flex-grow text-white h-min {wrapperClass}">
	<canvas
		bind:this={canvasElement}
		style="opacity: {showCanvas ? 1 : 0};z-index: {showCanvas
			? 2
			: -1};position: absolute; pointer-events: none;transform: scale(0.5); top: 16px; left: 0.5rem; filter:none; transform-origin: top left;{customStyles};{canvasStyles ||
			''}"
	/>
	{#if !hide}
		<textarea
			id="promptInput"
			bind:this={inputElement}
			use:adjustOnChange
			{placeholder}
			autocapitalize="false"
			style="
        width: 100%;
        font-size: 16px;
        outline: none;
		caret-width: 2px;
		border: 1.5px solid #161a1f;
        line-height: 22px;
        transition:all 0.2s ease;
        color: {showCanvas ? 'transparent' : ''};
        placeholder-color: {showCanvas ? 'transparent' : ''};
        resize: none;height: 62px;
        {customStyles}
      "
			{disabled}
			class="p-4 block w-full max-h-[48vh] bg-black mb-0 rounded-2xl text-white"
			on:input={adjustHeight}
			on:change={adjustHeight}
			autocorrect="false"
			spellcheck="false"
			bind:value={inputString}
			on:keydown={handleKeydown}
		/>
		<!-- Shadow Textarea -->
		<textarea
			bind:this={shadowTextarea}
			class="p-4 block w-full bg-black max-h-[48vh] mb-0 rounded-2xl text-white"
			style="visibility:hidden;  font-size: 16px;
			outline: none;
			border: 1.5px solid #161a1f;
			line-height: 22px;height:min-content;width:100%; position:absolute;{customStyles}"
		/>
	{/if}
</div>

<style>
	textarea::placeholder {
		opacity: 0.69;
	}
</style>
